import { General } from '../../walkthrough/devices/mobile/General'
import StartHere from '../../startHere/devices/mobile/Index'
import { Save } from '../../walkthrough/devices/mobile/Save'
import { Publication } from '../../walkthrough/devices/mobile/Publication'

const Personalization = () => {

	const path = window.location.pathname

	return (
		<>
			<General/>
			<Publication/>
			<Save/>
			{path !== '/psl/onboarding' && <StartHere />}
		</>
	)
}

export default Personalization